import { useEffect, useRef, useState } from 'react';

import { removeQueryParam } from '@eneco/common/path';
import { useFlowHooks } from '@eneco/flows/utils/FlowProvider';

import { OfferChangeNotification } from '../components/OfferChangeNotification';
import { FlowContextSme } from '../context';
import { getCostDetails, getMonthlyPriceChange, isReturnFromEmail, PriceChangeStatus } from '../helpers';
import { RETURN_SOURCE_PARAM } from '../helpers/misc';
import { Offer } from '../types';

export const useOfferChangeNotification = (availableOffers: Offer[]) => {
  const { useFlowSelector, useBasketSelector } = useFlowHooks<FlowContextSme>();

  const returnedFromEmailRef = useRef(isReturnFromEmail());
  const [priceChange, setPriceChange] = useState<PriceChangeStatus>('unchanged');

  const companyName = useFlowSelector(state => state.context.companyName);

  const cachedOffers = useBasketSelector(state => state.context.cachedOffers);

  useEffect(() => {
    removeQueryParam(RETURN_SOURCE_PARAM);
  }, []);

  useEffect(() => {
    if (availableOffers?.length > 0 && cachedOffers && cachedOffers?.length > 0) {
      const currentCosts = availableOffers.map((currentOffer: Offer) => getCostDetails(currentOffer));
      const cachedCosts = cachedOffers.map(cachedOffer => cachedOffer.costDetails || []);
      setPriceChange(getMonthlyPriceChange(currentCosts, cachedCosts));
    }
  }, [availableOffers, cachedOffers]);

  if (returnedFromEmailRef.current && companyName) {
    return <OfferChangeNotification companyName={companyName} priceChange={priceChange} />;
  }
  return null;
};
